<div class="gains-and-losses">
  <app-breadcrumb></app-breadcrumb>
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 md:col-span-8">
      <mat-card class="bg-primary">
        <div class="welcome-card flex justify-between px-4 pt-4">
          <div class="pr-12">
            <div class="text-2xl mb-4 text-white leading-snug">
              Your Prysm web dashboard
            </div>
            <p class="m-0 text-muted text-base leading-snug">
              Manage your Prysm validator and beacon node, analyze your
              validator performance, and control your wallet all from a simple
              web interface
            </p>
          </div>
          <img
            src="/assets/images/designer.svg"
            alt="designer"
            />
        </div>
      </mat-card>
      <div class="py-3"></div>
      <app-validator-performance-summary></app-validator-performance-summary>
      <div class="py-3"></div>
      <app-validator-performance-list></app-validator-performance-list>
    </div>
    <div class="col-span-12 md:col-span-4">
      <app-beacon-node-status></app-beacon-node-status>
      <div class="py-4"></div>
      <app-latest-gist-feature></app-latest-gist-feature>
      <div class="py-4"></div>
      <mat-card class="bg-primary">
        <p class="m-0 text-muted text-base leading-snug">
          Want to monitor your system process such as logs from your beacon node
          and validator? Our logs page has you covered
        </p>
        <a routerLink="/dashboard/system/logs"><button mat-stroked-button>View
            Logs</button></a>
      </mat-card>
    </div>
  </div>
</div>
